export const FETCH_PARKED = "[MIS] FETCH_PARKED";
export const FETCH_PARKED_START = "[MIS] FETCH_PARKED_START";
export const FETCH_PARKED_SUCCESS = "[MIS] FETCH_PARKED_SUCCESS";
export const FETCH_PARKED_ERROR = "[MIS] FETCH_PARKED_ERROR";

export const SET_PARKED_FILTER = "[MIS] SET_PARKED_FILTER";

export const SET_PARKED_PAGINATION = "[MIS] SET_PARKED_PAGINATION";

export const VIEW_PARKED_VISIT_LOADING_START = "[MIS] VIEW_PARKED_VISIT_LOADING_START";
export const VIEW_PARKED_VISIT_LOADING_END = "[MIS] VIEW_PARKED_VISIT_LOADING_END";
export const RESET_PARKED_FILTER = "[MIS] RESET_PARKED_FILTER";
export const SET_PARKED_AUTO_NEXT_VISIT = "[MIS] SET_PARKED_AUTO_NEXT_VISIT";

export const fetchMisParked = (payload) => {
    return {
        type: FETCH_PARKED,
        payload
    };
};

export const setMisParkedFilter = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_PARKED_FILTER,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const resetParkedFilter = () => {
    return {
        type: RESET_PARKED_FILTER,
    };
}

export const setParkedAutoNextVisit = (autoNextVisit) => {
    return {
        type: SET_PARKED_AUTO_NEXT_VISIT,
        autoNextVisit
    };
}
